// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__I1HAX","button--isMenu":"button_button--isMenu__7BpXP","narrow":"button_narrow__oHMT5"};